<template>
  <span
    class="jd-file-type-icon"
    :class="`jd-file-type-icon--${badgeKind}`"
    :style="{ width: `${size}px`, height: `${size}px` }"
    aria-hidden="true"
  >
    <svg
      class="jd-file-type-icon__page"
      :width="size"
      :height="size"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M10 4.5h12.5L30 12.5V35.5H10V4.5Z"
        fill="#F9FAFB"
        stroke="#D0D5DD"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M22.5 4.5V12.5H30"
        stroke="#D0D5DD"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
    <span class="jd-file-type-icon__badge">{{ badgeLabel }}</span>
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  fileType: {
    type: String,
    default: "",
  },
  fileName: {
    type: String,
    default: "",
  },
  size: {
    type: Number,
    default: 40,
  },
});

const EXT_FROM_MIME = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
};

const normalizedExt = computed(() => {
  const mime = String(props.fileType || "").toLowerCase();
  if (EXT_FROM_MIME[mime]) return EXT_FROM_MIME[mime];

  const fromType = mime.split(/[/.]/).filter(Boolean).pop() || "";
  if (["pdf", "doc", "docx"].includes(fromType)) return fromType;

  const fromName = String(props.fileName || "")
    .toLowerCase()
    .split(".")
    .pop();
  if (["pdf", "doc", "docx"].includes(fromName)) return fromName;
  return "pdf";
});

const badgeKind = computed(() => (normalizedExt.value === "pdf" ? "pdf" : "doc"));

const badgeLabel = computed(() => normalizedExt.value.toUpperCase());
</script>

<style scoped>
.jd-file-type-icon {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

.jd-file-type-icon__page {
  display: block;
}

.jd-file-type-icon__badge {
  position: absolute;
  left: 4%;
  bottom: 14%;
  padding: 2px 3px;
  border-radius: 2px;
  font-family: Inter, sans-serif;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  color: #ffffff;
  white-space: nowrap;
}

.jd-file-type-icon--pdf .jd-file-type-icon__badge {
  background: #d92d20;
}

.jd-file-type-icon--doc .jd-file-type-icon__badge {
  background: #1570ef;
}
</style>
